<template>
  <DialogHeader>
    <div class="flex gap-4 -ml-2">
      <DialogTitle>Congratulations!</DialogTitle>
    </div>
  </DialogHeader>
  <div class="px-7 pb-6 pt-5 w-auto sm:w-[390px]">
    <img
      alt="Congratulations"
      src="/images/congrats.svg"
      class="block mx-auto mb-9"
    />
    <div class="text-neutral-300 text-center text-sm tracking-wide">
      <p class="font-bold">Congratulations!</p>
      <p>
        You have successfully upgraded to the
        {{ currentSubscriptionPlan?.plan?.title }} Plan!
      </p>
      <p class="mt-2 mb-10">Enjoy the new features!</p>
      <Button type="button" @click="handleClose">Continue</Button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { Button } from '@ui/components/button';
import { DialogTitle, DialogHeader } from '@ui/components/dialog';

const emit = defineEmits(['modalClosed']);
const store = useStore();

const currentSubscriptionPlan = computed(
  () => store.getters['workspace/getCurrentSubscriptionPlan']
);

const handleClose = () => {
  emit('modalClosed');
};
</script>
